import { React, useEffect, useState } from 'react';

import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from '@mui/material';

import { Alerta } from '../../components/alerta';
import circularProgress from '../../components/circularProgress';
import PageHeader from '../../components/pageHeader';
import { formatDate } from '../../utils/dateUtils';
import { fetchFlask } from '../../utils/fetchFlask';
import '../css/chamado.css';

const getField = (chamado, keys) => {
    for (const key of keys) {
        if (chamado?.[key] !== undefined && chamado?.[key] !== null) {
            return chamado[key];
        }
    }

    return '';
};

const MeusChamados = () => {
    const [chamados, setChamados] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);

    useEffect(() => {
        async function fetchChamados () {
            const response = await fetchFlask('listarMeusChamados');

            if (Array.isArray(response)) {
                setChamados(response);
            } else if (Array.isArray(response.chamados)) {
                setChamados(response.chamados);
            } else {
                setMessage(response.message || 'Não foi possível carregar seus chamados.');
                setStatus(response.status || 'error');
                setOpenAlerta(true);
            }

            setIsLoading(false);
        };

        fetchChamados();
    }, []);

    return (
        <Box className='mainBox chamado-page'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />
            <PageHeader icon={ListAltRoundedIcon}>
                Meus Chamados
            </PageHeader>

            {isLoading && circularProgress()}

            {!isLoading && chamados.length === 0 && (
                <Typography color='text.secondary' sx={{ mt: 2 }}>
                    Nenhum chamado encontrado.
                </Typography>
            )}

            {!isLoading && chamados.length > 0 && (
                <TableContainer component={Paper} className='chamado-table'>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Departamento</TableCell>
                                <TableCell>Categoria</TableCell>
                                <TableCell>Título</TableCell>
                                <TableCell>Descrição</TableCell>
                                <TableCell>Comentário</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Data Criação</TableCell>
                                <TableCell>Última Alteração</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {chamados.map((chamado, index) => (
                                <TableRow key={getField(chamado, ['id']) || index}>
                                    <TableCell>{getField(chamado, ['departamento'])}</TableCell>
                                    <TableCell>{getField(chamado, ['categoria'])}</TableCell>
                                    <TableCell>{getField(chamado, ['titulo'])}</TableCell>
                                    <TableCell className='chamado-table-description'>
                                        {getField(chamado, ['descricao'])}
                                    </TableCell>
                                    <TableCell className='chamado-table-comment'>
                                        {getField(chamado, ['comentario'])}
                                    </TableCell>
                                    <TableCell>{getField(chamado, ['status'])}</TableCell>
                                    <TableCell>{formatDate(getField(chamado, ['data_criacao']))}</TableCell>
                                    <TableCell>{formatDate(getField(chamado, ['ultima_alteracao']))}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Box>
    );
};

export default MeusChamados;
